import { Component, OnInit } from '@angular/core';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import { firstValueFrom } from 'rxjs';
import { StaticPageUpdateDto } from 'src/app/shared/dtos/staticPage/staticPageUpdateDto';
import { PageType } from 'src/app/shared/enums/pageType';
import { StaticPageService } from 'src/app/shared/services';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-frequently-asked-questions',
  templateUrl: './frequently-asked-questions.component.html',
  styleUrls: ['./frequently-asked-questions.component.scss'],
})
export class FrequentlyAskedQuestionsComponent implements OnInit {
  constructor(
    private staticPageService: StaticPageService,
    private loadingService: LoadingService,
    private notificationService: NotificationService
  ) {}

  staticPageUpdateDto: StaticPageUpdateDto = this.emptyModel();
  dataSource: any;
  popupVisible: boolean = false;
  isVisibleEditor: boolean = false;
  showDeleteConfirm: boolean = false;
  itemToDelete: number | null = null;
  submitted: boolean = false;
  
  toolbarButtonOptions: DxButtonTypes.Properties = {
    text: 'Ön İzleme',
    stylingMode: 'text',
    onClick: () => (this.popupVisible = true),
  };

  ngOnInit(): void {
    this.getList();
  }

  getList() {
    this.staticPageService
      .getByPageType(PageType.FrequentlyAskedQuestions)
      .subscribe((data) => {
        this.dataSource = data;
      });
  }

  openEditor() {
    this.staticPageUpdateDto = this.emptyModel();
    this.isVisibleEditor = true;
  }

  closeEditor() {
    this.isVisibleEditor = false;
  }

  async save() {
    this.submitted = true;

    if (
      !this.staticPageUpdateDto.title ||
      !this.staticPageUpdateDto.content
    ) {
      this.notificationService.show('Lütfen tüm zorunlu alanları doldurunuz.');
      return;
    }

    this.loadingService.show();

    if (this.staticPageUpdateDto.id > 0) {
      await firstValueFrom(this.staticPageService.update(this.staticPageUpdateDto.id, this.staticPageUpdateDto));
    } else {
      await firstValueFrom(this.staticPageService.create(this.staticPageUpdateDto));
    }

    this.getList();
    this.staticPageUpdateDto = this.emptyModel();
    this.submitted = false;
    this.notificationService.show('Başarı ile kaydedildi');
    this.loadingService.hide();
  }

  listSelectionChanged(selectedItem: any) {
    this.isVisibleEditor = true;
    this.definationModel(selectedItem);
  }

  confirmDelete(id: number): void {
    this.itemToDelete = id;
    this.showDeleteConfirm = true;
  }

  cancelDelete(): void {
    this.showDeleteConfirm = false;
    this.itemToDelete = null;
  }

  async confirmDeleteItem(): Promise<void> {
    if (this.itemToDelete !== null) {
      this.loadingService.show();
      await firstValueFrom(this.staticPageService.delete(this.itemToDelete));
      this.getList();
      this.staticPageUpdateDto = this.emptyModel();
      this.notificationService.show('Başarı ile silindi');
      this.loadingService.hide();
      this.showDeleteConfirm = false;
      this.itemToDelete = null;
    }
  }

  async delete(id: number){
    this.loadingService.show()
    await firstValueFrom(this.staticPageService.delete(id));
    this.getList();
    this.staticPageUpdateDto = this.emptyModel();
    this.notificationService.show('Başarı ile silindi')
    this.loadingService.hide()
  }

  async webListUpdate(staticPageUpdateDto: StaticPageUpdateDto, value: boolean){
    this.loadingService.show()
    staticPageUpdateDto.isWebSiteList = value
    await  firstValueFrom(this.staticPageService.update(staticPageUpdateDto.id, staticPageUpdateDto));
    this.getList();
    this.staticPageUpdateDto = this.emptyModel();
    this.notificationService.show(value ? 'Yayına alındı':'Yayından kaldırıldı')
    this.loadingService.hide()
  }
  getShortContent(content: string): string {
    if (content.length > 100) {
      return content.substring(0, 100) + '...';
    }
    return content;
  }

  definationModel(data: any) {
    this.staticPageUpdateDto.id = data.id;
    this.staticPageUpdateDto.title = data.title;
    this.staticPageUpdateDto.content = data.content;
    this.staticPageUpdateDto.tag = data.tag;
    this.staticPageUpdateDto.imageUrl = data.imageUrl;
    this.staticPageUpdateDto.pageType = data.pageType;
    this.staticPageUpdateDto.metaKeyword = data.metaKeyword;
    this.staticPageUpdateDto.metaDescription = data.metaDescription;
  }

  emptyModel() {
    return {
      id: 0,
      title: '',
      content: '',
      tag: '',
      imageUrl: '',
      pageType: PageType.FrequentlyAskedQuestions,
      metaKeyword: '',
      metaDescription: '',
    };
  }
}
